import { render, staticRenderFns } from "./AutoSizeTextarea.vue?vue&type=template&id=15d0620a&"
import script from "./AutoSizeTextarea.vue?vue&type=script&lang=ts&"
export * from "./AutoSizeTextarea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports